export default "__VITE_ASSET__CwYgNQH3__"